export const VERSION = 'v1.2.0';
export const BUILD_DATE = '2026-05-11';
export const COMPANY_CN = '扬州红影智投文化科技有限公司';
export const COMPANY_EN = 'Yangzhou Hongying Zhitou Culture & Technology Co., Ltd.';
